<template>
  <form @submit.prevent="handleFormSubmit" class="form">
    <h1 class="heading">{{ $t("password recovery") }}</h1>
    <div class="input-container">
      <label class="label">SMS</label>
      <input
        v-model="recoveryCode"
        @input="handleUserInput"
        type="text"
        placeholder="SMS"
        class="input"
      />
    </div>
    <div class="submit">
      <button type="submit" class="submit-button button filled">
        {{ $t("confirm") }}
      </button>
      <router-link to="/auth/login" class="login-button">{{
        $t("entrance")
      }}</router-link>
    </div>
    <div class="resend">
      <a
        @click="handleRecoveryCodeResend"
        class="button filled resend-button"
        :class="{ disabled: isTimerGoingOn }"
      >
        {{ $t("resend") }}
      </a>
      <timer
        v-if="isTimerGoingOn"
        class="timer"
        @timerExpire="handleTimerExpire"
      />
    </div>
  </form>
</template>

<script>
import Timer from "@/components/auth/Timer";

export default {
  props: {
    isTimerGoingOn: Boolean
  },
  components: {
    timer: Timer
  },
  data() {
    return {
      recoveryCode: ""
    };
  },
  methods: {
    handleFormSubmit() {
      this.$emit("checkRecoveryCode");
    },
    handleUserInput() {
      // Передаем имя пользователя в родительский компонент
      this.$emit("setRecoveryCode", this.recoveryCode);
      // Если отображалась ошибка, скрываем ее
      if (this.$store.getters.recoveryErrorMessage) {
        this.$store.dispatch("clearRecoveryErrorMessage");
      }
    },
    handleTimerExpire() {
      this.$emit("timerExpire");
    },
    handleRecoveryCodeResend() {
      this.$emit("fetchRecoveryCode");
    }
  }
};
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
}

.heading {
  margin-bottom: 20px;
  font-weight: normal;
  font-size: 36px;
}

.input-container {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.label {
  font-size: 15px;
}

.input {
  width: 70%;
  padding: 10px;
  font-size: 15px;
  outline: none;
  background-color: #ffffff;
  border: 1px solid #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.submit {
  margin-top: 20px;
  width: 70%;
  align-self: flex-end;
  display: flex;
  align-items: center;
}

.submit-button {
  padding: 15px 60px;
}

.login-button {
  margin-left: 18px;
  font-size: 13px;
  color: #acb5c5;
  text-decoration: none;
}

.resend {
  margin-top: 30px;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid grey;
}

.resend-button {
  padding: 15px 30px;
  font-size: 13px;
}

.timer {
  margin-top: 20px;
}
</style>
